/**
 * Function to only load the ChiliPiper script on form submission rahter than on page load
 * @param router Router name in ChiliPiper
 * @param options @see https://help.chilipiper.com/hc/en-us/articles/360053800373-About-Concierge-Snippet-and-JS-API
 */

import { getUTMs } from '../../../utils/handleCookies';

const loadChiliPiperScript = (router, options) => {
  const script = document.createElement('script');
  script.src = `https://onupkeep.chilipiper.com/concierge-js/cjs/concierge.js`;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.type = 'text/javascript';
  script.addEventListener('load', () => {
    window.ChiliPiper?.submit('onupkeep', router, options);
  });
  document.head.appendChild(script);
};

/**
 * Function to submit the form to ChiliPiper
 * @param data Form data
 * @param router Router name in ChiliPiper
 */
export const submitChiliPiper = (data, router) => {
  const utms = getUTMs();

  const options = {
    trigger: 'ThirdPartyForm',
    formId: 'demo-form',
    lead: {
      firstname: data?.firstname,
      lastname: data?.lastname,
      email: data?.email,
      phone: data?.phone,
      country: data?.country,
      state: data?.state,
      companyname: data?.companyname,
      DoNotRoute: data?.DoNotRoute,
      LeadStatus: data?.LeadStatus,
      number_of_technicians_range__c: data?.Number_of_Technicians_Range__c,
      Language: data?.Language,
      ...utms,
    },
  };

  loadChiliPiperScript(router || 'demo-request-router-l5ae3u', options);
};
